/**
 * Formate un nombre sans séparateur de milliers pour l'export
 * Utilisé pour Excel et PDF pour éviter les caractères parasites
 */
export const formatNumberForExport = (value) => {
  if (value === null || value === undefined) return "0";
  
  // Convertir en nombre si c'est une chaîne
  const num = typeof value === 'string' ? parseFloat(value) || 0 : value;
  
  // Retourner sans séparateur de milliers, avec 2 décimales
  return num.toFixed(0);
};

/**
 * Formate un montant pour l'export sans symbole monétaire
 */
export const formatCurrencyForExport = (value) => {
  if (value === null || value === undefined) return "0";
  
  const num = typeof value === 'string' ? parseFloat(value) || 0 : value;
  
  // Format: 1234567 au lieu de 1.234.567
  return num.toFixed(0);
};

/**
 * Formate une date pour l'export
 */
export const formatDateForExport = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR');
};

/**
 * Nettoie une chaîne pour l'export (enlève les virgules, points, etc.)
 */
export const sanitizeForExport = (value) => {
  if (typeof value === 'string') {
    // Enlève tout ce qui n'est pas un chiffre, point ou signe moins
    return value.replace(/[^\d.-]/g, '');
  }
  return value;
};